import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Fill, Icon, Stroke, Style } from 'ol/style';
import { MapServiceService } from 'src/app/modules/map/services/Map-service/map-service.service';
import { SideNavService } from 'src/app/modules/map/services/sidenav/side-nav.service';

import { DeleteAnnotationComponent } from '../delete-annotation/delete-annotation.component';
import { EditAnnotationRightComponent } from '../edit-annotation-right/edit-annotation-right.component';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-zoom',
  templateUrl: './zoom.component.html',
  styleUrls: ['./zoom.component.css'],
})
export class ZoomComponent implements OnInit, OnDestroy {
  annotationForm!: FormGroup;
  data: any;
  attributeList: any
  clicked: any = [];
  decrypted: any;
  keyMes = 'mapId';
  mapId: any;
  // selectionZoom =
  //   '<span><strong>Zoom to Selection</strong><br>Click to zoom map to feature selected.<br>(Press <strong>Z</strong>)</span>';
  editTip = '<span>Edit this feature’s attribute data.</span>';
  deleteTip = '<span>Delete this feature.</span>';
  // back =
  //   '<span><strong>Back</strong><br>Go back to previous multiple selection</span>';
  // closeRight =
  //   '<span><strong>Close</strong><p>Clear map selection(s) and close panel</p></span>';
  myOptions12 = {
    showDelay: 500,
    'tooltip-class': 'new-tooltip-class12',
  };
  myEdit = {
    showDelay: 500,
    'tooltip-class': 'new-tooltip-class13',
  };
  myDelete = {
    showDelay: 500,
    'tooltip-class': 'new-tooltip-class14',
  };
  myBack = {
    showDelay: 500,
    'tooltip-class': 'new-tooltip-class16',
  };
  myClose = {
    showDelay: 500,
    'tooltip-class': 'new-tooltip-class15',
  };
  constructor(
    private sideNavService: SideNavService,
    private dialog: MatDialog,
    public mapService: MapServiceService,
    private fb: FormBuilder,
  ) {
    //
  }

  ngOnInit(): void {
    this.mapId = this.mapService.mapData.map_data.map_data.id.toString();
    this.sideNavService.clickedInfo(0);
    this.data = this.sideNavService.dataPassToRightPanel;
    this.mapService.preSelectedAnnotation = parseInt(this.data.id);
    this.sideNavService.sideNavState('open');
    this.annotationForm = this.fb.group({
      mapsData: this.fb.array([]),
    });
    const attributeData  = this.data?.user_fields;
    this.attributeList = JSON.parse(attributeData);
    }


  closeRightpanel(): void {
    //after create annotation now destroy features on close
    // if (this.sideNavService.newAnnoCreated) {
    this.sideNavService.panelSize(false);
    this.sideNavService.activeFeatureList = [];
    if (this.mapService.result) {
      this.mapService.result.getSource().clear();
      this.sideNavService.saveFeatureListData = [];
    }
    this.sideNavService.newAnnoCreated = false;
    // }

    this.mapService.preSelectedAnnotation = '';
    if (
      this.sideNavService.zoomFeatures &&
      this.sideNavService.zoomFeatures.length
    ) {
      for (let i = 0; i < this.sideNavService.zoomFeatures.length; i++) {
        if (
          this.sideNavService.zoomFeatures[i].get('id') ==
          this.sideNavService.zoomId
        ) {
          if (
            this.sideNavService.zoomFeatures[i].get('type') == 'point' ||
            this.sideNavService.zoomFeatures[i].get('type1') == 'point'
          ) {
            this.sideNavService.zoomFeatures[i].setStyle(
              this.pointStyle(this.sideNavService.zoomFeatures[i].get('color'))
            );
          }
          if (
            this.sideNavService.zoomFeatures[i].get('type') == 'line' ||
            this.sideNavService.zoomFeatures[i].get('type1') == 'line'
          ) {
            this.sideNavService.zoomFeatures[i].setStyle(
              this.lineStyle(this.sideNavService.zoomFeatures[i].get('color'))
            );
          }
          if (
            this.sideNavService.zoomFeatures[i].get('type') == 'polygon' ||
            this.sideNavService.zoomFeatures[i].get('type1') == 'polygon'
          ) {
            this.sideNavService.zoomFeatures[i].setStyle(
              this.polygonStyle(
                this.sideNavService.zoomFeatures[i].get('color')
              )
            );
          }
          if (
            this.sideNavService.zoomFeatures[i].get('type') ==
              'geomcollection' ||
            this.sideNavService.zoomFeatures[i].get('type1') == 'geomcollection'
          ) {
            this.sideNavService.zoomFeatures[i].setStyle(
              this.geomcollectionStyle(
                this.sideNavService.zoomFeatures[i].get('color')
              )
            );
          }
        }
      }
    }
    // this.sideNavService.sideNavState('closed');
    this.sideNavService.closeRightSideNav();
  }

  goBack(): void {
    this.sideNavService.maintainHistory();
  }

  clickToZoom(data: any) {
    const features = this.mapService.annotationFeature.getFeatures();

    for (let i = 0; i < features.length; i++) {
      if (data.id == features[i].get('id')) {
        const extent = features[i].getGeometry().getExtent();
        this.mapService.mapLayer
          .getView()
          .fit(extent, this.mapService.mapLayer.getSize());
        break;
      }
    }
  }

  edit(data: any) {
    let data1: any;
    if (this.data.subType) {
      this.sideNavService.annotationType = 'editFolder';
      data1 = {
        annotation_id: data.id,
        map_id: parseInt(this.mapId),
        name: data.name,
        description: data.description,
        folderId: this.data.folderId,
        annotation_color: data.annotation_color,
        attributeData: this.attributeList
      };
    } else {
      this.sideNavService.annotationType = 'edit';
      data1 = {
        annotation_id: data.id,
        map_id: parseInt(this.mapId),
        name: data.name,
        description: data.description,
        annotation_color: data.annotation_color,
        attributeData: this.attributeList
      };
    }

    this.sideNavService.rightMenuClicked({
      component: EditAnnotationRightComponent,
      data: data1,
      history: false,
      push: false,
    });
    this.clicked = [];
  }

  delete(annotationId: any): void {
    const arr = [];
    arr.push(annotationId);
    this.dialog.open(DeleteAnnotationComponent, {
      data: {
        type: this.data.subType ? 'deleteFolder' : 'delete',
        id: arr,
      },
    });

    this.clicked = [];
  }

  pointStyle(color: any) {
    color = color.toUpperCase();
    let url: any;
    switch (color) {
      //red
      case '#FF0000':
        url = '/assets/img/tools/annotation_point1_red.png';
        break;
      //blue
      case '#0000FF':
        url = '/assets/img/tools/annotation_point1_blue.png';
        break;
      //Yellow
      case '#FFFF00':
        url = '/assets/img/tools/annotation_point1_yellow.png';
        break;
      //Purple
      case '#800080':
        url = '/assets/img/tools/annotation_point1_purple.png';
        break;
      //Green
      case '#00FF00':
        url = '/assets/img/tools/annotation_point1_green.png';
        break;

      //Orange
      default:
        url = '/assets/img/tools/annotation_point1_orange.png';
    }
    return new Style({
      image: new Icon({
        //annotation_point1 is a resize image of original image
        src: url,
        imgSize: [80, 150],
        offset: [-20, -37],
        scale: 1.0,
        opacity: 1.0,
      }),
    });
  }

  lineStyle(color: any) {
    color = color.toUpperCase();
    return new Style({
      fill: new Fill({
        color: color,
      }),
      stroke: new Stroke({
        color: color,
        width: 4,
      }),
    });
  }

  polygonStyle(color: any) {
    color = color.toUpperCase();
    return new Style({
      // fill: new Fill({
      //   color: 'rgb(204, 229, 236 , 0.3)',
      // }),
      stroke: new Stroke({
        color: color,
        width: 4,
      }),
    });
  }

  geomcollectionStyle(color: any) {
    color = color.toUpperCase();
    let url: any;
    switch (color) {
      //red
      case '#FF0000':
        url = '/assets/img/tools/annotation_point1_red.png';
        break;
      //blue
      case '#0000FF':
        url = '/assets/img/tools/annotation_point1_blue.png';
        break;
      //Yellow
      case '#FFFF00':
        url = '/assets/img/tools/annotation_point1_yellow.png';
        break;
      //Purple
      case '#800080':
        url = '/assets/img/tools/annotation_point1_purple.png';
        break;
      //Green
      case '#00FF00':
        url = '/assets/img/tools/annotation_point1_green.png';
        break;

      //Orange
      case '#FFA500':
        url = '/assets/img/tools/annotation_point1_orange.png';
        break;
      default:
      // code block
    }
    return new Style({
      //color modify
      stroke: new Stroke({
        color: color,
        width: 5,
      }),
      image: new Icon({
        src: url,
        imgSize: [80, 150],
        offset: [-20, -37],
        scale: 1.0,
        opacity: 1.0,
      }),
    });
  }

  ngOnDestroy() {
    this.mapService.preSelectedAnnotation = '';
    if (this.sideNavService.zoomFeatures) {
      if (this.sideNavService.zoomFeatures.length) {
        for (let i = 0; i < this.sideNavService.zoomFeatures.length; i++) {
          if (
            this.sideNavService.zoomFeatures[i].get('id') ==
            this.sideNavService.zoomId
          ) {
            if (
              this.sideNavService.zoomFeatures[i].get('type') == 'point' ||
              this.sideNavService.zoomFeatures[i].get('type1') == 'point'
            ) {
              this.sideNavService.zoomFeatures[i].setStyle(
                this.pointStyle(
                  this.sideNavService.zoomFeatures[i].get('color')
                )
              );
            }
            if (
              this.sideNavService.zoomFeatures[i].get('type') == 'line' ||
              this.sideNavService.zoomFeatures[i].get('type') == 'line'
            ) {
              this.sideNavService.zoomFeatures[i].setStyle(
                this.lineStyle(this.sideNavService.zoomFeatures[i].get('color'))
              );
            }
            if (
              this.sideNavService.zoomFeatures[i].get('type') == 'polygon' ||
              this.sideNavService.zoomFeatures[i].get('type') == 'polygon'
            ) {
              this.sideNavService.zoomFeatures[i].setStyle(
                this.polygonStyle(
                  this.sideNavService.zoomFeatures[i].get('color')
                )
              );
            }
            if (
              this.sideNavService.zoomFeatures[i].get('type') ==
                'geomcollection' ||
              this.sideNavService.zoomFeatures[i].get('type') ==
                'geomcollection'
            ) {
              this.sideNavService.zoomFeatures[i].setStyle(
                this.geomcollectionStyle(
                  this.sideNavService.zoomFeatures[i].get('color')
                )
              );
            }
          }
        }
      }
    }
  }
}
